import { Fragment, useCallback, useMemo } from "react";
import GamePage from "../../components/GameSelect/GamePage";
import MobileSearch from "../Search/mobile-search";
import TopTab from "../Home/components/topTab";
import { useSelector } from "react-redux";
import GameCatalog from "../../components/GameCatalog";
import { languageTransfer } from "../../utils/languageTransfer";
import i18next from "i18next";
import { getPromotionImages } from "../Promotion/PromotionList";
import List from "../Promotion/components/LIST";
import useCasinoType from "../../hook/useCasinoType";
import { filterType } from "../../hook/useGameListFilter";
import FavoriteGameCatalog from "../../components/FavoriteGameCatalog";
import LoadingForLiveLayout from "../../components/Loading/LoadingForLiveLayout";

const Lottery = () => {
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  const { allGames, categorizedGames } = isHandleAllGame;

  const casinoType = useCasinoType();

  const lotteryGameList = useMemo(() => {
    return filterType({
      gameList: allGames,
      casinoType: casinoType,
    });
  }, [allGames]);

  const promotionList = List();

  return (
    <Fragment>
      <section className="md:hidden">
        <TopTab />
      </section>
      <section className="py-common-padding-y"></section>

      <section className="md:hidden">
        <MobileSearch />
      </section>
      <section>
        {loadingStatus ? (
          <LoadingForLiveLayout itemClass="md:!h-[300px] h-[180px]" />
        ) : (
          <GameCatalog
            hiddenButtonNavigator
            mainTitle={"Lottery"}
            list={lotteryGameList}
            itemClass="md:!h-[300px] h-[180px]"
            swiperProps={{
              customPerView: "live-layout",
            }}
          />
        )}
        <GameCatalog
          list={[...promotionList]}
          listType="promotion"
          mainTitle={"Promotions"}
          typeTitle={``}
          itemClass="!h-[250px]"
          swiperProps={{
            delay: 1,
            speed: 25000,
            swiperClassName: "custom-swiper-wrapper",
            customPerView: "promotion-layout",
          }}
        />
      </section>
    </Fragment>
  );
};

export default Lottery;
